// @ts-nocheck
import copy from 'copy-to-clipboard'
import { takeEvery, call } from 'redux-saga/effects'
import { getLoginLinkAsUser } from '../actions'
import makeAPIRequest from 'store/entities/api/sagas'
import { showSuccess } from 'store/entities/toastr/utils'
import { get } from 'lodash'

export default function* getLoginLinkAsUserSaga() {
  yield takeEvery(getLoginLinkAsUser, handleLoginLinkAsUserRequest)
}

export function* handleLoginLinkAsUserRequest({ payload: { id } }: any) {
  try {
    const response = yield call(makeAPIRequest, `/users/${id}/impersonate`, {
      method: 'GET',
    })
    copy(get(response, 'data.url'))

    showSuccess({ content: 'Link copied successfully' })
  } catch (badResponse) {
    console.log(badResponse)
  }
}
